import { render, staticRenderFns } from "./DecisionDetail.vue?vue&type=template&id=c4df90fe&scoped=true"
import script from "./DecisionDetail.vue?vue&type=script&lang=js"
export * from "./DecisionDetail.vue?vue&type=script&lang=js"
import style0 from "./DecisionDetail.vue?vue&type=style&index=0&id=c4df90fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4df90fe",
  null
  
)

export default component.exports